import React, { useEffect, useState } from 'react';

import { IonContent, useIonViewWillEnter } from '@ionic/react';
// import { IonBackButton, IonButtons, IonButton } from '@ionic/react';
import { IonList, IonItem, IonSpinner, IonButton, IonIcon } from '@ionic/react';
import { gridOutline, listOutline } from 'ionicons/icons';

// import Price from '../components/Price';
// import OptionService from '../services/option';
// import SearchService from '../services/product';
import AuthResource from '../resources/Auth';
import CartResource from '../resources/Cart';
import usePromotions from '../hooks/Promotions/usePromotions';
import usePromotionPosts from '../hooks/Promotions/usePromotionPosts';
import OptionService from '../services/option';
// import SkeletonPromotions from '../components/Promotions/SkeletonPromotions';
import GridItem from '../components/Promotions/GridItem';
import Item, { getDiscount } from '../components/Promotions/Item';
import HeaderPromotions from '../components/Promotions/HeaderPromotions';
import PostCard from '../components/Promotions/PostCard';
import '../components/Promotions/promotions-grid.css';
// import { IonSkeletonText } from '@ionic/react';

// import { pricetagsOutline as promotions } from 'ionicons/icons';

const PromotionsPage = (props) => {
  const [promotions, promotionsLoading, promotionsError, loadPromotions] = usePromotions();
  const [promotionPosts, promotionPostsLoading, promotionPostsError, loadPromotionPosts] = usePromotionPosts();
  const { toast } = props;
  const { history } = props;
  const [options, setOptions] = useState(null);
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [viewMode, setViewMode] = useState('grid');

  const addProductToCart = async (prod, nome_prodotto = 'Prodotto') => {
    if (!(await AuthResource.isLogged)) {
      toast.current.add({
        message: `Accedi o registrati`,
        color: 'warning',
      });
      history.push('/auth/login');
      return;
    }

    await CartResource.addProduct(prod);
    toast.current.add({
      message: `${nome_prodotto} aggiunto al carrello`,
    });
  };

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await OptionService.allClean();
        const optionsData = response.data.data;
        setOptions(optionsData);
      } catch (error) {
        console.error('Errore durante il caricamento delle opzioni:', error);
      } finally {
        setOptionsLoaded(true);
      }
    };

    fetchOptions();
  }, []);

  useIonViewWillEnter(async () => {
    await Promise.all([loadPromotions(), loadPromotionPosts()]);
    setDataLoaded(true);
  });

  // I dati già caricati restano visibili durante un ricaricamento (es. ritorno dal dettaglio prodotto)
  const hasPosts = !promotionPostsError && promotionPosts.length > 0;
  const hasProducts = !promotionsError && promotions && promotions.length > 0;
  const isLoading = !dataLoaded || !optionsLoaded || promotionsLoading || promotionPostsLoading;

  // Prima i prodotti con immagine, poi per sconto decrescente
  const sortedPromotions = hasProducts
    ? [...promotions].sort((first, second) => {
        const firstHasImage = first.immagine && first.immagine !== '' ? 1 : 0;
        const secondHasImage = second.immagine && second.immagine !== '' ? 1 : 0;

        if (firstHasImage !== secondHasImage) return secondHasImage - firstHasImage;

        return getDiscount(second) - getDiscount(first);
      })
    : [];

  return (
    <>
      <HeaderPromotions />
      <IonContent fullscreen>
        {/* Post promozionali attivi */}
        {hasPosts && (
          <div className="promotion-posts">
            {promotionPosts.map((post) => (
              <PostCard key={post.id} post={post} />
            ))}
          </div>
        )}

        {/* Prodotti in offerta */}
        {/* Cambio vista griglia / lista */}
        {hasProducts && (
          <div className="promotions-view-toggle">
            <IonButton
              fill="clear"
              aria-label={viewMode === 'grid' ? 'Vista a lista' : 'Vista a griglia'}
              onClick={() => setViewMode(viewMode === 'grid' ? 'list' : 'grid')}
            >
              <IonIcon slot="icon-only" icon={viewMode === 'grid' ? listOutline : gridOutline} />
            </IonButton>
          </div>
        )}

        {hasProducts && viewMode === 'list' && (
          <IonList>
            {sortedPromotions.map((prod, key) => (
              <Item key={key} prod={prod} history={history} addProductToCart={addProductToCart} options={options} />
            ))}
          </IonList>
        )}

        {hasProducts && viewMode === 'grid' && (
          <div className="promotions-grid">
            {sortedPromotions.map((prod, key) => (
              <GridItem
                key={key}
                prod={prod}
                history={history}
                addProductToCart={addProductToCart}
                options={options}
              />
            ))}
          </div>
        )}

        {/* Volantino, mostrato dopo post e prodotti */}
        {options?.volantino && (
          <iframe
            src={`${options.volantino}`}
            style={{ width: '100%', height: '100vh', border: 'none' }}
            title="PDF Viewer"
          />
        )}

        {isLoading && !hasPosts && !hasProducts && (
          <div className="ion-text-center ion-padding">
            <IonSpinner name="crescent" />
            <p>Caricamento in corso...</p>
          </div>
        )}

        {!isLoading && !hasPosts && !hasProducts && !options?.volantino && (
          <IonItem>Non ci sono promozioni attive</IonItem>
        )}
      </IonContent>
      {/* <IonContent>

        <IonList>
          {!promotionsLoading && !promotionsError ?
            <>
              {
                promotions?.map((prod, key) => (
                  <Item key={key} prod={prod} history={history} addProductToCart={addProductToCart} />
                ))
              }
            </>
            :
            <SkeletonPromotions />
          }
        </IonList>
      </IonContent> */}
    </>
  );
};

export default PromotionsPage;
